<template>
	<div data-component="pack-deals">
		<div data-element="deals-list">
			<slot />
			<pack-deal-item
				v-for="(deal, index) in getDeals"
				:key="deal.id"
				:deal="deal"
				:index="index"
				:isDisabled="isDealDisabled(index)"
				@onPlayDeal="handlePlayDeal(index)"
				@onShowDealRecording="handleShowDealRecording"
			/>
		</div>
		<portal
			to="modal"
			v-if="previewIsVisible"
		>
			<modal-inner
				@close="closePreview"
				heading="Preview deals"
			>
				<deal-summaries
					:deals="getDeals"
					:currentIndex="gameStateIndex"
				/>
			</modal-inner>
		</portal>
		<portal
			to="modal"
			v-if="dealRecordingIsVisible"
		>
			<modal-inner
				@close="closeDealRecording"
				heading="Deal run-through"
			>
				<div data-element="deal-recording">
					<video-viewer :src="dealRecordingSrc" />
					<actions
						:actions="getDealRecordingActions"
						@actionClick="onActionClick"
					/>
				</div>
			</modal-inner>
		</portal>
	</div>
</template>

<script>

	import PackDealItem from '@/components/dealPacks/PackDealItem';
	import ModalInner from '@/components/ui/modal/ModalInner';
	import DealSummaries from '@/components/diagrams/DealSummaries';
	import VideoViewer from '@/components/uploads/VideoViewer';
	import Actions from '@/components/ui/Actions';
	import routeParams from '@/mixins/routeParams';
	import actionClick from '@/mixins/actionClick';
	import { SIMULATOR_MODES } from '@/consts';

	export default {
		components: {
			PackDealItem,
			ModalInner,
			DealSummaries,
			VideoViewer,
			Actions
		},
		mixins: [routeParams, actionClick],
		props: {
			dealPack: {
				type: Object,
				default: undefined
			}
		},
		data: () => ({
			previewIsVisible: false,
			simulatorIsVisible: false,
			gameStateIndex: undefined,
			dealRecordingIsVisible: false,
			dealRecordingSrc: undefined
		}),
		computed: {
			getShowPreview () {
				return !(this.getContext === 'dealStore' ||
					this.getContext === 'myDeals');
			},
			getSimulatorMode () {
				return this.getShowPreview ? SIMULATOR_MODES.PREVIEW : SIMULATOR_MODES.STUDY;
			},
			getDeals () {
				return this.dealPack?.deals || [];
			},
			getGameIds () {
				return this.getDeals.map(deal => deal.id);
			},
			getGameStates () {
				return this.getDeals?.map((deal) => {
					return deal.deal;
				});
			},
			getDealRecordingActions () {
				return {
					primary: [],
					secondary: [
						{
							text: 'Close',
							actionId: 'closeDealRecording'
						}
					]
				};
			}
		},
		watch: {},
		methods: {
			isDealDisabled (index) {
				if (index > 0) {
					const prevIndex = index - 1;
					const prevDeal = this.getDeals[prevIndex];
					return !prevDeal?.isComplete;
				}
				return false;
			},
			resetGameStateIndex () {
				this.gameStateIndex = undefined;
			},
			openPreview () {
				this.previewIsVisible = true;
			},
			async openSimulator (index) {
				const gameMode = this.$store.getters['gameEngine/getGameMode']({ legacyMode: this.getSimulatorMode });
				const roomToken = await this.$store.dispatch('gameEngine/getRoomToken', {
					mode: gameMode,
					context: 'deal_pack',
					dealIds: this.getGameIds.slice(index),
					exitRedirectUrl: window.location.href,
					dealRecordingEnabled: [],
					metadata: {
						dealPackId: this.dealPack?.id
					}
				});
				await this.$store.dispatch('gameEngine/openGameEngine', { roomToken, newTab: false });
			},
			closePreview () {
				this.previewIsVisible = false;
				this.resetGameStateIndex();
			},
			closeSimulator () {
				this.simulatorIsVisible = false;
				this.resetGameStateIndex();
			},
			handlePlayDeal (index) {
				this.gameStateIndex = index;
				if (this.getShowPreview) {
					this.openPreview();
				} else {
					this.openSimulator(index);
				}
			},
			handleShowDealRecording (src) {
				this.dealRecordingSrc = src;
				this.dealRecordingIsVisible = true;
			},
			closeDealRecording () {
				this.dealRecordingIsVisible = false;
				this.dealRecordingSrc = undefined;
			}
		}
	};

</script>

<style lang="scss" scoped>

	[data-component='pack-deals'] {
		[data-element='deals-list'] {
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			gap: 12px;

			@media (max-width: 767px) {
				grid-template-columns: 1fr;
			}
		}
	}

	[data-element='deal-recording'] {

		[data-component='actions'] {
			padding-bottom: 0;
		}
	}

</style>
